import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SlotCreationValues } from "pages/slots/slotsDetail/slotCreationModal/types";
import { WorkzoneType } from "sagas/types/regions";
import { RootState } from "store";
import { SlotsCreationStateType } from "./types/slotCreation";

export const initialState: SlotsCreationStateType = {
  actualRegion: "",
  workzones: [],
  fetchingWorkzones: false,
};

const SLICE_NAME = "slotCreation";

export const slotsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getWorkzonesFetch: (
      state: SlotsCreationStateType,
      action: PayloadAction<string>
    ) => {
      state.workzones = [];
      state.fetchingWorkzones = true;
    },
    getWorkzonesError: (state: SlotsCreationStateType) => {
      state.workzones = [];
      state.fetchingWorkzones = false;
    },
    getWorkzonesSuccess: (
      state: SlotsCreationStateType,
      action: PayloadAction<WorkzoneType[]>
    ) => {
      const { payload } = action;
      state.workzones = payload;
      state.fetchingWorkzones = false;
    },
    resetWorkzones: (state: SlotsCreationStateType) => {
      state.workzones = [];
    },
    setActualRegion: (
      state: SlotsCreationStateType,
      action: PayloadAction<string>
    ) => {
      state.actualRegion = action.payload;
    },
    createSlotRequest: (
      state: SlotsCreationStateType,
      action: PayloadAction<SlotCreationValues>
    ) => {},
    createSlotError: () => {},
    createSlotSuccess: () => {},
  },
});

export const slotSelector = (state: RootState) => state.slotCreation;

export const actions = slotsSlice.actions;

export default slotsSlice.reducer;
